import React, { useState, useEffect } from 'react';
import { Admin, Resource, useTranslate } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';

import './App.css';

import authProvider from './authProvider';
import Reducers from './Reducers';
import { Login, Layout } from './layout';
import { Dashboard } from './dashboard';
import customRoutes from './routes';
import englishMessages from './i18n/en';
import dataProviderFactory from './dataProvider';

import BookIcon from '@material-ui/icons/Book';

import RoleEdit from './role/RoleEdit';
import RoleList from './role/roleList';
import RoleCreate from './role/RoleCreate'
import ServerLog from './systemData/ServerLog';

import devices from './devices';
import Group from './Groups/Group';
import Room from './Rooms/Room';
import ListUser from './users/listUser';
import EditUser from './users/editUser';
import CreateUser from './users/createUser';
import Auth from './CustomizedUIs/Authorization';
import ServerStatus from './systemData/ServerStatus';
import InfoChannels from './infochannels/list';
import InfoChannelCreate from './infochannels/CreateInfoChannel';
import CategoryChannel from './category-channel/list';
import GroupChannel from './group-channel/list';
import Channel from './channel/list';
import CreateChannel from './channel/create';
import EditChannel from './channel/edit';
import Message from './message';
import Alarm from './alarm';
import Media from './media/ListMovie';
import CategoryMedia from './media/CategoryMedia';
import EditInfoChannel from './infochannels/edit';
import InfoPage from './info-page';
import MediaCreate from './media/create';
import MediaEdit from './media/edit';
import Support from './support';
import usageData from './usagedata/main';
import DeviceProfiles from './device-profiles/index';
import CreateDeviceProfiles from './device-profiles/create';
import EditDeviceProfiles from './device-profiles/edit';
import RemoteList from './remote-control/list'
import RemoteCreate from './remote-control/create'
import RemoteEdit from './remote-control/edit'
import RemoteMaping from './remote-control/keymap'
import ListDevices from './devices';
import CreateDevices from './devices/create';
import EditDevices from './devices/edit';
import CreateFirmware from './device-firmware/create'
import Firmwares from './device-firmware/list'
import EditFirmware from './device-firmware/edit'
import Settings from './settings';
import ServiceList from './ExternalService/list'
import ServiceCreate from './ExternalService/create'
import ServiceUpdate from './ExternalService/edit'
import CategoryService from './ExternalService/category'
import CalendarType from './calendar/calendarType';

const App = () => {
    const [dataProvider, setDataProvider] = useState(null as any);
    const translate = useTranslate();

    useEffect(() => {
        let restoreFetch;
        const fetchDataProvider = async () => {
            // restoreFetch = await fakeServerFactory(
            //     process.env.REACT_APP_DATA_PROVIDER
            // );
            const dataProviderInstance = await dataProviderFactory(
                process.env.REACT_APP_DATA_PROVIDER
            );
            setDataProvider(
                // GOTCHA: dataProviderInstance can be a function
                () => dataProviderInstance
            );
        };
        fetchDataProvider();
        return restoreFetch;
    }, []);

    if (!dataProvider) {
        return (
            <div className="loader-container">
                <div className="loader">{translate(`pos.common.loading`)}</div>
            </div>
        );
    }

    const specialCase = () => {
        let getPermissions: any = localStorage.getItem('userData')
        if (getPermissions) {
            let permissions: any = JSON.parse(getPermissions).permission
            if (permissions && permissions.functionAction && permissions.functionAction.filter((value: any) => value.function === 'Unit' && (value.isUpdate || value.isRead)).length > 0) return true
        }
        return false
    }

    return (
        <Admin
            title="DMD HOME Application"
            dataProvider={dataProvider}
            customReducers={Reducers}
            customRoutes={customRoutes}
            authProvider={authProvider}
            // dashboard={Dashboard}
            loginPage={Login}
            layout={Layout}
            i18nProvider={i18nProvider}>
            <Resource name='login'></Resource>
            <Resource name='dashboard' list={Dashboard}></Resource>
            <Resource name='channel'
                list={Auth(Channel, { functionName: 'Channels and programs', action: 'isRead' })}
                edit={Auth(EditChannel, { functionName: 'Channels and programs', action: 'isUpdate' })}
                create={Auth(CreateChannel, { functionName: 'Channels and programs', action: 'isCreate' })}>
            </Resource>
            <Resource name='categorychannel' list={Auth(CategoryChannel, { functionName: 'Channels and programs', action: 'isRead' })}></Resource>
            <Resource name='groupchannel' list={Auth(GroupChannel, { functionName: 'Channels and programs', action: 'isRead' })}></Resource>
            <Resource
                name="users"
                list={Auth(Auth(ListUser, { functionName: 'Admin rights/functions', action: 'isRead' }), { functionName: 'Admin users', action: 'isRead' })}
                edit={Auth(EditUser, { functionName: 'Admin rights/functions', action: 'isUpdate' })}
                create={Auth(Auth(CreateUser, { functionName: 'Admin rights/functions', action: 'isCreate' }), { functionName: 'Admin users', action: 'isCreate' })} />
            <Resource name="roles"
                list={Auth(RoleList, { functionName: 'Admin users', action: 'isRead' })}
                edit={Auth(RoleEdit, { functionName: 'Admin users', action: 'isUpdate' })}
                create={Auth(RoleCreate, { functionName: 'Admin users', action: 'isCreate' })}
                icon={BookIcon} />
            <Resource name="mailbox" list={Auth(Message, { functionName: 'Messages', action: 'isRead' })} />
            <Resource name="alarm" list={Auth(Alarm, { functionName: 'Alarms', action: 'isRead' })} />
            <Resource name="FunctionActions" />
            <Resource name="infochannel"
                list={Auth(InfoChannels, { functionName: 'Info channel (Management)', action: 'isRead' })}
                edit={Auth(EditInfoChannel, { functionName: 'Info channel (Management)', action: 'isUpdate' })}
                create={Auth(InfoChannelCreate, { functionName: 'Info channel (Management)', action: 'isCreate' })} />
            <Resource name="ServerStatus"
                list={Auth(ServerStatus, { functionName: 'System Data', action: 'isRead' })} />
            <Resource name="Serverlog"
                list={Auth(Auth(ServerLog, { functionName: 'Log', action: 'isRead' }), { functionName: 'System Data', action: 'isRead' })} />
            <Resource name="Entity/:name" list={Group} />
            <Resource name="Cluster/:id" list={Room} />
            <Resource name="devices" {...devices} />
            <Resource name="DeviceProfiles"
                list={Auth(DeviceProfiles, { functionName: 'Devices and profiles', action: 'isRead' })}
                create={Auth(CreateDeviceProfiles, { functionName: 'Devices and profiles', action: 'isCreate' })}
                edit={Auth(EditDeviceProfiles, { functionName: 'Devices and profiles', action: 'isUpdate' })} />
            <Resource name="Media"
                list={Auth(Media, { functionName: 'Media', action: 'isRead' })}
                edit={Auth(MediaEdit, { functionName: 'Media', action: 'isUpdate' })}
                create={Auth(MediaCreate, { functionName: 'Media', action: 'isCreate' })} />
            <Resource name='categorymedia' list={Auth(CategoryMedia, { functionName: 'Media', action: 'isRead' })}></Resource>
            <Resource name='infopage' list={Auth(InfoPage, { functionName: 'Info pages', action: 'isRead' })}></Resource>
            <Resource name='supporter' list={Support}></Resource>
            <Resource name='UsageData' list={usageData}></Resource>
            <Resource name='Remote' list={RemoteList} create={RemoteCreate} edit={RemoteEdit}></Resource>
            <Resource name='Keymap' edit={RemoteMaping}></Resource>
            <Resource name='ClientDevice' list={Auth(ListDevices, { functionName: 'Client devices', action: 'isRead' })}
                create={Auth(CreateDevices, { functionName: 'Client devices', action: 'isCreate' })}
                edit={specialCase() === true ? Auth(EditDevices, { functionName: 'Unit', action: 'isRead' }) : Auth(EditDevices, { functionName: 'Client devices', action: 'isUpdate' })}
            />
            <Resource name='DeviceFirmware'
                list={Auth(Firmwares, { functionName: 'Remote FirmWare', action: 'isRead' })}
                create={Auth(CreateFirmware, { functionName: 'Remote FirmWare', action: 'isCreate' })}
                edit={Auth(EditFirmware, { functionName: 'Remote FirmWare', action: 'isUpdate' })} />
            <Resource name='ExternalService'
                list={ServiceList}
                create={ServiceCreate}
                edit={ServiceUpdate} />
            <Resource name='CategoryService'
                list={CategoryService}
            />
            <Resource name='Settings'
                list={Settings} />
            
            <Resource name="calendarType"
                list={Auth(CalendarType, { functionName: 'Admin users', action: 'isUpdate' })} />
        </Admin>
    );
};

const i18nProvider = polyglotI18nProvider(locale => {
    if (locale === 'fr') {
        return import('./i18n/fr').then(messages => messages.default);
    }

    // Always fallback on english
    return englishMessages;
}, 'en');

export default App;
